import React from 'react'
import Chart from 'react-apexcharts'
import { RISK_REPORTS } from 'src/utils/constants/RiskReports'

const BarCharts = ({ series, categories, height, colors, type }) => {
  const options = {
    chart: {
      id: 'premium-and-claim',
    },
    colors: colors,
    plotOptions: {
      bar: {
        columnWidth: '45%',
        distributed: true,
      },
    },
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: false,
      horizontalAlign: 'center',
    },
    xaxis: {
      type: 'category',
      categories: categories,
      // floating: true,
      labels: {
        align: 'left',
        maxWidth: 100,
        trim: true,
        hideOverlappingLabels: false,
        textAnchor: 'middle',
        style: {
          colors: '#333333',
          fontSize: '12px',
          fontWeight: 400,
          cssClass: 'apexcharts-yaxis-label',
        },
        offsetX: 0,
        offsetY: 0,
        rotateAlways: false,
        rotate: 0,
        formatter: function (value) {
          return `${value[0]} \n ${value[1]}`
        },
        /* formatter: function (value) {
          if (Array.isArray(value)) return value.map((e) => e + "\n");
          return value;
          //return `${value[0]} \n ${value[1]}`;
        }, */
      },
    },
    yaxis: {
      offsetY: -4,
      labels: {
        formatter: function (value) {
          if (type === 'AgeGraph') {
            return value
          } else {
            if (value >= 100) {
              return `${value > 0 ? value / 100 : 0} C`
            } else {
              return `${parseFloat(value).toFixed(2)} L`
            }
          }
        },
      },
      tooltip: {
        enabled: false,
      },
    },
  }
  return (
    <Chart
      options={options}
      series={series}
      type={RISK_REPORTS?.BAR}
      height={height}
    />
  )
}

export default BarCharts
